import { motion, useMotionValueEvent } from "framer-motion"
import { useState } from "react"
import { MdClose, MdMenu } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import logo from "../assets/iconOnly.png"

export default function Nav({ scrollY, noInverse }) {

    const [color, setColor] = useState("#fff")
    const [backgroundColor, setBackGroundColor] = useState("#000")
    const [invert, setInvert] = useState(1)
    const navigate = useNavigate()
    const m = window.innerWidth < 961;

    useMotionValueEvent(scrollY, "change", (latest) => {

        if(noInverse) {
            return
        }

        // console.log(scrollYProgress)
        const scroll = latest

        const opacity = Number((scroll / window.innerHeight).toFixed(2)) * 100
        const inRange = (opacity < (m ? 75 : 95) || (opacity >= (m ? 175 : 195)))

        if(color !== "#FFF" && inRange) {
            setColor("#FFF")
            setInvert(1)
            setBackGroundColor("#000")
            
        } else if(color !== "#000" && !inRange) {
            setColor("#000")
            setInvert(0)
            setBackGroundColor("#FFF")
        }


    })

    const navs = [" ", "Home", "About Us", "Our Work", "Our Team"]

    const [nav, setNav] = useState(false)

    const onNavigate = (to) => {

        const focused = window.location.pathname

        if(focused.trim() === "/" && to.trim() === "/") {
            const container = document.getElementById("app")
            container.scrollTo({ top: 0, behavior: 'smooth' })
            return
        }

        navigate(to)

    }

    function NavButton({ to, children }) { 

        return (
            <div className="pointer" onClick={() => onNavigate(to)}>
                {children}
            </div>
        )
    }
    

    if(window.innerWidth < 789) {

        return (
            <>
                <motion.div 
                    style={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 2000, 
                        height: "10vh",
                        padding: "0 10px",
                        display: 'flex',
                        justifyContent: 'center',
                        width: "calc(100vw - 20px)" 
                    }}
                    animate={{ backgroundColor, boxShadow: "3px 4px 15px #00000030" }}
                    transition={{ duration: 0.3 }}
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                    }}>
                        <motion.img 
                            src={logo}
                            alt="P&S Tech Logo"
                            id="logo-img"
                            style={{
                                "-webkit-filter": `brightness(0) invert(${invert})`,
                                filter: `brightness(0) invert(${invert})`,
                                width: 40,
                                height: 40,
                            }}
                            onClick={() => navigate("/")}
                        />
                        {/* <h1 style={{ color }}>PandS Tech</h1> */}
                        <div className="pointer" onClick={() => setNav(true)} >
                            <MdMenu size="40px" color={color} />
                        </div>
                    </div>
                </motion.div>
                <motion.div
                    initial={{
                        y: 100,
                        opacity: 0
                    }}
                    animate={{
                        y: !nav ? 100 : 0,
                        opacity: !nav ? 0 : 1
                    }}
                    style={{
                        position: 'fixed',
                        top: 0,
                        width: 'calc(100vw - 20px)',
                        height: '100vh',
                        backgroundColor: '#000',
                        padding: "10px",
                        zIndex: 50000,
                        color: "#FFF",
                        pointerEvents: nav ? "all" : "none",
                        textAlign: 'center'
                    }}
                >
                    <div className="pointer" onClick={() => setNav(false)} >
                        <MdClose size="40px" color="#FFF" />
                    </div>
                    <br/>
                    <motion.img 
                        src={logo}
                        alt="P&S Tech Logo"
                        style={{
                            "-webkit-filter": `brightness(0) invert(${invert})`,
                            filter: `brightness(0) invert(${invert})`,
                            width: 100,
                            height: 100,
                            objectFit: 'cover',
                            opacity: 0.4
                        }}
                    />
                    <br />
                    <br />
                    {navs.map(nv => {

                        const lnk = "/" + (nv === "Home" ? "" : nv.toLowerCase().split(" ").join("-"))
                        const location = window.location.pathname

                        return (
                            <div onClick={() => { onNavigate(lnk); setNav(false) }} style={{
                                margin: 20,
                            }} key={nv}>
                                <p style={{
                                    fontSize: 30,
                                    color: lnk === location ? "var(--primary)" : "#FFF"
                                }}>{nv}</p>
                            </div>
                        )
                    })}
                    <div style={{ position: 'absolute', bottom: 50, margin: "0 auto", width: "100vw" }}>
                        <p style={{ textAlign: 'center', color: "var(--primary)" }}>
                            PandS Tech Solutions
                        </p>
                    </div>
                </motion.div>
            </>
        )
    }

    return (
        <motion.div
            style={{
                position: 'sticky',
                top: 0,
                zIndex: 2000
            }}
            animate={{ backgroundColor, boxShadow: "3px 4px 15px #00000030" }}
            transition={{ duration: 0.3 }}
        >
            <div id="nav-wrapper" >
                <div className="flex row centerX" >
                    <motion.img 
                        src={logo}
                        alt="P&S Tech Logo"
                        id="logo-img"
                        style={{
                            "-webkit-filter": `brightness(0) invert(${invert})`,
                            filter: `brightness(0) invert(${invert})`
                        }}
                    />
                    {/* <h1 style={{ margin: "0 10px" }}>P&S Tech</h1> */}
                </div>
                <div className="flex centerX end" >
                    <div className="flex row between centerX" style={{ width: "50vw" }}>
                        {navs.map(itm => {

                            const lnk = "/" + (itm === "Home" ? "" : itm.toLowerCase().split(" ").join("-"))

                            if(!itm.trim()) {
                                return <div key={itm} />
                            }
                            
                            return (
                            <div key={itm}>
                                <NavButton to={lnk}>
                                    <motion.div className="pointer"
                                        style={{
                                            borderRadius: 100,
                                            width: 120,
                                            textAlign: 'center',
                                            padding: "10px 0",
                                            backgroundColor: lnk === window.location.pathname ? "var(--primary)" : "transparent"
                                        }}
                                    >
                                        <motion.p animate={{ color }}>{itm}</motion.p>
                                    </motion.div>
                                </NavButton>
                            </div>
                        )})}
                    </div>
                </div>
            </div>
        </motion.div>
    )
}